import { StudioHttpRequest, StudioMailRequest } from '@/features/code-runner'

export enum Theme {
  Dark,
  Light,
}

export const Links = {
  authenticationArticle: 'https://support.knots.io/hc/en-us/articles/15762186696850',
  deployToZendeskArticle: 'https://support.knots.io/hc/en-us/articles/15763181133202',
  crontabGuruGuide: 'https://crontab.guru/',
  privacyPolicy: 'https://knots.io/privacy-policy/',
  slackNotificationsWorkflowGuide: ' https://support.knots.io/hc/en-us/articles/26415959245330',
}

export enum Runtime {
  NodeJS = 'nodejs',
  NodeJS18 = 'node18',
  NodeJS22 = 'node22',
  Python3 = 'python3',
  Python3_10 = 'python3_10',
}

export enum TemplateStatus {
  Draft = 'draft',
  Published = 'published',
}

export const RuntimeOptions = [
  { label: 'Python 3', value: Runtime.Python3_10 },
  { label: 'Node.js', value: Runtime.NodeJS22 },
]

export enum RouteType {
  HTTP = 'httpV1',
  HTTP_V2 = 'httpV2',
  Mail = 'mail',
  Cron = 'cron',
  Flow = 'flow',
}

export const RouteTypeOptions = [
  { label: 'HTTP', value: RouteType.HTTP },
  { label: 'HTTP V2', value: RouteType.HTTP_V2 },
  { label: 'E-Mail', value: RouteType.Mail },
  { label: 'Cron', value: RouteType.Cron },
  { label: 'Flow', value: RouteType.Flow },
]

export const RouteTemplateStatusOptions = [
  { label: 'Draft', value: TemplateStatus.Draft },
  { label: 'Published', value: TemplateStatus.Published },
]

export const InitialHttpRequestPayload: StudioHttpRequest = {
  method: 'POST',
  query: {
    //@ts-expect-error new lib sets never
    order: 'desc',
  },
  //@ts-expect-error it is okay for test reqeust
  body: {
    ticketId: 123,
  },
}

export const InitialEmailRequestPayload = {
  messageId: '123',
  subject: 'Email subject',
  text: 'Text',
} satisfies Partial<StudioMailRequest>
